import React, {useState} from 'react'
import FieldDropdown from './FieldDropdown'
import { _FETCH } from '../lib/patches'
import { useStateContext } from '../context/StateContext'
import { useQuery } from '@tanstack/react-query'
import { useAuthContext } from '../hooks/useAuthContext'
import VisDiv from './frontend_components/VisDiv'
import { MdCloudUpload } from "react-icons/md";
import { IoIosArrowDropdownCircle, IoIosArrowDropupCircle } from "react-icons/io";
import { errorAlert } from '../lib/utils'
import { AiTwotoneDelete } from 'react-icons/ai';
import { FaFilePdf } from "react-icons/fa";
import {FiEdit} from 'react-icons/fi'

export const PdfDocumentPin = ({pdf, hideAddPdfButton, hideDeletePdfButton, hideViewer, pdfManagement, clickTitle, pdfs=[], setPdfs, editFn = ()=>{}, restoreFn = ()=>{}, deleteFn = ()=>{}  }) => {
    const pdfExists = pdfs?.some?.((item) => item?.url === pdf?.url)
    const addPdfFn = () => {
        const pdfDoc = {title: pdf?.title, url: pdf?.url, pdfId: pdf?._id, file: pdf?.file}
        //console.log("pdf kwejdfnjke", pdfDoc)
        if(pdf?.url) { 
          if(!pdfExists){
          //pdfUrl(pdf?.url)
          setPdfs([...pdfs, pdfDoc])}
          else {
            //pdfUrl("")
            setPdfs(!Array.isArray(pdfs) ? [] : pdfs?.filter?.((item) => item?.url !== pdf?.url))
          }
        }
        else {
        errorAlert("ERRORE, URL NON TROVATA")}
    }
    const [viewPdf, setViewPdf] = useState(false)
    return (
        <VisDiv> 
            <div style={{display: "flex", alignItems:"center"}}>
                <VisDiv rules={[!hideViewer]} style={{marginRight:"10px", cursor:"pointer"}} onClick={()=>setViewPdf(!viewPdf )}>
                    {viewPdf ? <IoIosArrowDropupCircle size={25}/> : <IoIosArrowDropdownCircle size={25}/>}
                </VisDiv>
                <VisDiv>
                <VisDiv style={{marginRight:"10px"}} rules={[hideViewer]}>
                    <FaFilePdf
                    size={22}
                    color={"#324d67"}
                    />
                </VisDiv>
                </VisDiv>
                <h3 style={{cursor:"pointer"}} onClick={clickTitle}>{pdf?.title}</h3>
                <VisDiv rules={[!hideAddPdfButton, !pdfExists]} style={{marginLeft:"10px", cursor:"pointer"}} onClick={()=>pdfManagement ? restoreFn(pdf) : addPdfFn()}>
                    <MdCloudUpload color={"green"} size={25}/>
                </VisDiv>
                <VisDiv rules={[!hideDeletePdfButton, pdfExists || pdfManagement]} style={{marginLeft:"10px", cursor:"pointer"}} onClick={()=>pdfManagement ? deleteFn(pdf) : addPdfFn()}>
                    <AiTwotoneDelete color={"red"} size={25}/>
                </VisDiv>
                <VisDiv rules={[pdfManagement]} style={{marginLeft:"10px", cursor:"pointer"}} onClick={()=>editFn(pdf)}>
                    <FiEdit color={"green"} size={20}/>
                </VisDiv>
            </div>
            <VisDiv rules={[viewPdf, !hideViewer]}>
                <PdfViewerAndDownloader pdfUrl={pdf?.url} />
            </VisDiv>

        </VisDiv>
    )
}

export const PdfViewerAndDownloader = ({ pdfUrl }) => {
    return (
      <div>
        {pdfUrl ? (
          <>
            {/* PDF Viewer with iframe */}
            <div style={{ height: '600px', overflow: 'auto' }}>
              <iframe
                src={pdfUrl}
                width="100%"
                height="100%"
                style={{ border: 'none' }}
                title="PDF Viewer"
              ></iframe>
            </div>
  
            {/* Download Link */}
  {/*           <a href={pdfUrl} download="sanity-file.pdf">
              Download PDF
            </a> */}
          </>
        ) : (
          <p>Il pdf non è disponibile</p>
        )}
      </div>
    );
  }